import { Mastercategory, Category, Subcategory, Recommendation, Narrative, ReportSection, Rating} from "../Objects/languageObjects";
// import Language_v2 from "../Objects/language_v2";
// import { MAS, CAT, SUB, REC, NAR  } from "./typeDirs";
const types = [Mastercategory, Category, Subcategory, Recommendation, Narrative, ReportSection, Rating]

let langTypeMap = {}
for(let t of types){
  langTypeMap[t.getTypeDir()] = t
}

export{langTypeMap}